import { Component, OnInit } from '@angular/core';
import { GlobalStoreService } from '../../_services/global-store.service';
import { UtilService } from '../../_services/util.service';
import { AuthService } from '../../../auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  toggleProfile: boolean = false;
  user: any;
  isMobile: boolean = false;
  color: string = '#A3DAF6';
  constructor(
    private globalStore: GlobalStoreService,
    private utilService: UtilService,
    private authService: AuthService,
    private router: Router
  ) {
    this.isMobile = this.utilService.isMobile();
  }

  ngOnInit(): void {}

  toggleSideNav() {
    this.utilService.toggleSideNav.next(true);
  }

  collapseMenu() {
    this.utilService.toggleSideNav.next(false);
  }

  logout() {
    this.authService.removeToken();
    this.router.navigate(['/login']);
  }
}
